import { render, staticRenderFns } from "./RoadStatCard.vue?vue&type=template&id=39dcbe4f"
import script from "./RoadStatCard.vue?vue&type=script&lang=js"
export * from "./RoadStatCard.vue?vue&type=script&lang=js"
import style0 from "./RoadStatCard.vue?vue&type=style&index=0&id=39dcbe4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports